// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* align with theme primary */
.model-mgmt-page {
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  background: var(--page-bg);
  min-height: auto;
  padding: 1.5rem 0 2rem;
  box-sizing: border-box;
}

.model-mgmt-page .page-header-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.65rem 1rem;
  padding: clamp(0.75rem, 2.5vw, 1rem) clamp(0.85rem, 3vw, 1.25rem);
  background: var(--card);
  border-radius: var(--radius);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  margin-bottom: 0.5rem;
}
.model-mgmt-page .page-header-title h5 {
  margin: 0;
  font-weight: 600;
  font-size: 1.15rem;
  color: var(--foreground);
  letter-spacing: -0.02em;
}
.model-mgmt-page .page-header-title .btn-primary {
  background: linear-gradient(135deg, var(--brand-500) 0%, var(--brand-700) 100%);
  border: none;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: var(--radius-sm);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.model-mgmt-page .page-header-title .btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-glow);
}

.model-mgmt-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.model-mgmt-card {
  background: var(--card);
  border-radius: var(--radius);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  transition: box-shadow 0.25s ease, transform 0.2s ease, background 0.2s ease;
}
.model-mgmt-card:hover {
  background: var(--card-hover);
  box-shadow: var(--shadow-md);
}
.model-mgmt-card .card-body {
  padding: clamp(0.85rem, 3vw, 1.5rem) clamp(0.85rem, 3.5vw, 1.75rem);
  overflow: visible;
}

.model-mgmt-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid var(--border);
  position: relative;
}
.model-mgmt-card__header::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 48px;
  height: 2px;
  background: linear-gradient(90deg, var(--primary), transparent);
  border-radius: 1px;
}

.model-mgmt-card__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.05rem;
}
.model-mgmt-card__title .model-mgmt-card__project {
  color: var(--muted-foreground);
  font-size: 0.9rem;
}
.model-mgmt-card__title .model-mgmt-card__separator {
  color: var(--muted-foreground);
  font-weight: 300;
}
.model-mgmt-card__title .model-mgmt-card__model-name {
  font-weight: 600;
  color: var(--foreground);
}

.model-mgmt-card__badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}
.model-mgmt-card__badges .badge {
  font-weight: 600;
  letter-spacing: 0.3px;
  padding: 0.3rem 0.65rem;
  border-radius: var(--radius-sm);
}
.model-mgmt-card__badges .badge-success {
  background: linear-gradient(135deg, var(--brand-500) 0%, var(--brand-600) 100%);
  color: var(--primary-foreground);
  border: none;
}
.model-mgmt-card__badges .badge-secondary {
  background: var(--secondary);
  color: var(--secondary-foreground);
}

.model-mgmt-table-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--card);
  box-shadow: var(--shadow-sm);
}

.model-mgmt-table {
  width: 100%;
  min-width: 800px;
  margin: 0;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.model-mgmt-table thead {
  background: linear-gradient(180deg, var(--muted) 0%, var(--page-bg-subtle) 100%);
  position: sticky;
  top: 0;
  z-index: 1;
}
.model-mgmt-table thead th {
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--muted-foreground);
  border-bottom: 2px solid var(--border);
  white-space: nowrap;
}
.model-mgmt-table tbody tr {
  border-bottom: 1px solid var(--border);
  transition: background 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}
.model-mgmt-table tbody tr:hover {
  background: var(--primary-soft);
}
.model-mgmt-table tbody tr:last-child {
  border-bottom: none;
}
.model-mgmt-table td {
  padding: 0.85rem 1rem;
  vertical-align: middle;
  border: none;
}
.model-mgmt-table .model-mgmt-version {
  min-width: 140px;
}
.model-mgmt-table .model-mgmt-version .model-mgmt-version__num {
  font-weight: 500;
  color: var(--foreground);
}
.model-mgmt-table .model-mgmt-version .model-mgmt-version__model {
  font-size: 0.8rem;
  color: var(--muted-foreground);
  margin-top: 0.15rem;
}
.model-mgmt-table .model-mgmt-images {
  min-width: 100px;
  white-space: nowrap;
}
.model-mgmt-table .model-mgmt-classes {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.model-mgmt-table .model-mgmt-metric {
  min-width: 70px;
  font-variant-numeric: tabular-nums;
}
.model-mgmt-table .model-mgmt-actions {
  position: relative;
  min-width: 140px;
  white-space: nowrap;
}
.model-mgmt-table .model-mgmt-actions .model-mgmt-actions__group {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-wrap: nowrap;
}
.model-mgmt-table .model-mgmt-actions .btn {
  padding: 0.35rem 0.5rem;
  font-size: 0.8rem;
}
.model-mgmt-table .model-mgmt-actions .btn-group {
  position: relative;
}

@media (max-width: 767.98px) {
  .model-mgmt-table-wrapper {
    overflow-x: visible;
    border: none;
    background: transparent;
    box-shadow: none;
    border-radius: 0;
  }
  .model-mgmt-table {
    min-width: 0;
    display: block;
    font-size: 0.85rem;
  }
  .model-mgmt-table thead {
    display: none;
  }
  .model-mgmt-table tbody {
    display: block;
  }
  .model-mgmt-table tbody tr {
    display: block;
    padding: 0.65rem 0.8rem;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    background: var(--card);
  }
  .model-mgmt-table tbody tr + tr {
    margin-top: 0.6rem;
  }
  .model-mgmt-table tbody tr:last-child {
    border-bottom: 1px solid var(--border);
  }
  .model-mgmt-table td {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.28rem 0;
    min-width: 0;
    text-align: right;
  }
  .model-mgmt-table td::before {
    content: attr(data-label);
    flex: 0 0 8.5rem;
    max-width: 45%;
    text-align: left;
    font-size: 0.66rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--muted-foreground);
  }
  .model-mgmt-table .model-mgmt-version,
  .model-mgmt-table .model-mgmt-images,
  .model-mgmt-table .model-mgmt-classes,
  .model-mgmt-table .model-mgmt-metric,
  .model-mgmt-table .model-mgmt-actions {
    min-width: 0;
    max-width: none;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  }
  .model-mgmt-table .model-mgmt-version__stack {
    min-width: 0;
  }
  .model-mgmt-table .model-mgmt-actions {
    display: block;
    margin-top: 0.45rem;
    padding-top: 0.6rem;
    border-top: 1px solid var(--border);
    text-align: left;
  }
  .model-mgmt-table .model-mgmt-actions::before {
    display: none;
  }
  .model-mgmt-table .model-mgmt-actions .model-mgmt-actions__group {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
  }
}
.model-mgmt-empty {
  text-align: center;
  padding: 2rem;
  color: var(--muted-foreground);
}
.model-mgmt-empty .btn {
  margin-top: 0.75rem;
}

.model-mgmt-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: var(--muted-foreground);
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.65rem;
  border-radius: var(--radius-full);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  border: 1px solid transparent;
  transition: transform 0.15s ease, box-shadow 0.2s ease;
}

.status-badge::before {
  content: "";
  width: 0.45rem;
  height: 0.45rem;
  border-radius: var(--radius-full);
  margin-right: 0.45rem;
  background-color: currentColor;
  opacity: 0.75;
}

.status-badge:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.status-badge--training {
  background: var(--info-soft);
  color: var(--info);
  border-color: var(--info);
}

.status-badge--complete {
  background: var(--primary-soft);
  color: var(--success);
  border-color: var(--success);
}

.status-badge--error {
  background: var(--destructive-soft);
  color: var(--destructive);
  border-color: var(--destructive);
}

.status-badge--queued {
  background-color: var(--warning-soft);
  color: var(--warning);
  border-color: var(--warning);
}

.status-badge--queued::before {
  content: "⏳";
  margin-right: 4px;
}

.status-badge--pending {
  background: var(--warning-soft);
  color: var(--warning);
  border-color: var(--warning);
}

.training-log-area {
  max-height: 240px;
  overflow-y: auto;
  background: var(--page-bg-subtle);
  color: var(--foreground);
  border-radius: var(--radius-sm);
  padding: 0.75rem 1rem;
  font-family: var(--font-mono);
  font-size: 0.75rem;
  line-height: 1.4;
  box-shadow: inset 0 0 0 1px var(--border);
}

.training-log-area .log-line:not(:last-child) {
  margin-bottom: 0.35rem;
  border-bottom: 1px dashed var(--border);
  padding-bottom: 0.25rem;
}

.lf-metrics {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.lf-metrics__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.lf-metrics__title {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--foreground);
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.lf-metrics__title i {
  font-size: 0.75rem;
  color: var(--primary);
}

.lf-metrics__count {
  font-family: var(--font-mono);
  font-size: 0.66rem;
  color: var(--muted-foreground);
  font-variant-numeric: tabular-nums;
}

.lf-metrics__label {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--muted-foreground);
  line-height: 1.2;
}

.lf-metrics__label-icon {
  font-size: 0.7rem;
  color: var(--lf-metric-accent, var(--primary));
}

.lf-metrics__scope {
  font-family: var(--font-mono);
  font-size: 0.56rem;
  letter-spacing: 0.04em;
  text-transform: none;
  padding: 0.05rem 0.3rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  color: var(--muted-foreground);
  background: var(--page-bg-subtle);
}

.lf-metrics__hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
  align-items: center;
  gap: 1rem;
  padding: 0.85rem 1rem;
  background: var(--card);
  border: 1px solid var(--border);
  border-left: 3px solid var(--lf-metric-accent, var(--primary));
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm);
}

.lf-metrics__hero--solo {
  grid-template-columns: minmax(0, 1fr);
}

.lf-metrics__hero-info {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
}

.lf-metrics__hero-value {
  font-family: var(--font-mono);
  font-size: clamp(1.6rem, 4vw, 2.1rem);
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: var(--foreground);
  font-variant-numeric: tabular-nums;
}

.lf-metrics__hero-meter .lf-metrics__meter {
  height: 8px;
}

.lf-metrics__unit {
  font-size: 0.55em;
  font-weight: 600;
  margin-left: 0.15rem;
  color: var(--muted-foreground);
}

.lf-metrics__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(var(--lf-metric-min, 148px), 100%), 1fr));
  gap: 0.6rem;
}

.lf-metrics__tile {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.6rem 0.7rem;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  transition: background-color var(--transition-fast), border-color var(--transition-fast);
}

.lf-metrics__tile:hover {
  background: var(--card-hover);
  border-color: var(--border-strong);
}

.lf-metrics__value {
  font-family: var(--font-mono);
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: var(--foreground);
  font-variant-numeric: tabular-nums;
}

.lf-metrics__meter {
  height: 4px;
  border-radius: var(--radius-full);
  background: var(--muted);
  overflow: hidden;
}

.lf-metrics__meter-fill {
  display: block;
  height: 100%;
  border-radius: var(--radius-full);
  background: var(--lf-metric-accent, var(--primary));
  transition: width var(--transition-slow) ease;
}

.lf-metrics__note {
  font-size: 0.6rem;
  color: var(--muted-foreground);
  letter-spacing: 0.02em;
  min-height: 0.9em;
}

.lf-metrics__empty {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.7rem 0.85rem;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  font-size: 0.78rem;
  line-height: 1.4;
}

.lf-metrics__empty i {
  margin-top: 0.15rem;
  font-size: 0.8rem;
}

.lf-metrics__empty--info {
  background: var(--info-soft);
  border-color: var(--info);
  color: var(--info);
}

.lf-metrics__empty--danger {
  background: var(--destructive-soft);
  border-color: var(--destructive);
  color: var(--destructive);
}

.lf-metrics__empty--muted {
  background: var(--page-bg-subtle);
  color: var(--muted-foreground);
}

@media (max-width: 575.98px) {
  .lf-metrics__hero {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/management/modelManagement/styles/model-management.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAQY,6BAAA;AAK5B;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,iEAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,qBAAA;AAVF;AAYE;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAlCM;EAmCN,uBAAA;AAVJ;AAaE;EACE,+EAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,qDAAA;AAXJ;AAaI;EACE,2BAAA;EACA,8BAAA;AAXN;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAdF;;AAkBA;EACE,uBAlEW;EAmEX,4BAAA;EACA,+BAAA;EACA,4BAhEU;EAiEV,gBAAA;EACA,4EAAA;AAfF;AAiBE;EACE,6BAAA;EACA,4BAAA;AAfJ;AAkBE;EACE,mEAAA;EACA,iBAAA;AAhBJ;;AAqBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,sCAAA;EACA,kBAAA;AAlBF;AAoBE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,+DAAA;EACA,kBAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAnBF;AAqBE;EACE,8BAlHY;EAmHZ,iBAAA;AAnBJ;AAsBE;EACE,8BAvHY;EAwHZ,gBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,wBA9HM;AAyGV;;AAyBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAtBF;AAwBE;EACE,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;AAtBJ;AAyBE;EACE,+EAAA;EACA,gCAAA;EACA,YAAA;AAvBJ;AA0BE;EACE,4BAAA;EACA,kCAAA;AAxBJ;;AA6BA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;EACA,+BAAA;EACA,+BAAA;EACA,uBAAA;EACA,4BAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;AA1BF;AA4BE;EACE,gFAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AA1BJ;AA4BI;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BA1LU;EA2LV,sCAAA;EACA,mBAAA;AA1BN;AA8BE;EACE,sCAAA;EACA,sDAAA;EACA,eAAA;AA5BJ;AA8BI;EACE,+BAAA;AA5BN;AA+BI;EACE,mBAAA;AA7BN;AAiCE;EACE,qBAAA;EACA,sBAAA;EACA,YAAA;AA/BJ;AAmCE;EACE,gBAAA;AAjCJ;AAmCI;EACE,gBAAA;EACA,wBA3NI;AA0LV;AAoCI;EACE,iBAAA;EACA,8BA/NU;EAgOV,mBAAA;AAlCN;AAuCE;EACE,gBAAA;EACA,mBAAA;AArCJ;AAyCE;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvCJ;AA2CE;EACE,eAAA;EACA,kCAAA;AAzCJ;AA6CE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AA3CJ;AA6CI;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AA3CN;AA8CI;EACE,uBAAA;EACA,iBAAA;AA5CN;AA+CI;EACE,kBAAA;AA7CN;;AAuDA;EACE;IACE,mBAAA;IACA,YAAA;IACA,uBAAA;IACA,gBAAA;IACA,gBAAA;EApDF;EAuDA;IACE,YAAA;IACA,cAAA;IACA,kBAAA;EArDF;EAuDE;IACE,aAAA;EArDJ;EAwDE;IACE,cAAA;EAtDJ;EAyDE;IACE,cAAA;IACA,uBAAA;IACA,+BAAA;IACA,+BAAA;IACA,uBAAA;EAvDJ;EAyDI;IACE,kBAAA;EAvDN;EA0DI;IACE,sCAAA;EAxDN;EA4DE;IACE,aAAA;IACA,qBAAA;IACA,8BAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;IACA,iBAAA;EA1DJ;EA4DI;IACE,yBAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;IACA,kBAAA;IACA,gBAAA;IACA,yBAAA;IACA,sBAAA;IACA,8BA7UQ;EAmRd;EAgEE;;;;;IAKE,YAAA;IACA,eAAA;IACA,mBAAA;IACA,iBAAA;IACA,mBAAA;EA9DJ;EAiEE;IACE,YAAA;EA/DJ;EAkEE;IACE,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,mCAAA;IACA,gBAAA;EAhEJ;EAmEI;IACE,aAAA;EAjEN;EAoEI;IACE,aAAA;IACA,eAAA;IACA,WAAA;EAlEN;AACF;AA0EA;EACE,kBAAA;EACA,aAAA;EACA,8BA9Xc;AAsThB;AA0EE;EACE,mBAAA;AAxEJ;;AA6EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BA5Yc;AAkUhB;;AA8EA;EACE,oBAAA;EACA,mBAAA;EACA,wBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,6BAAA;EACA,sDAAA;AA3EF;;AA8EA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;EACA,qBAAA;EACA,8BAAA;EACA,aAAA;AA3EF;;AA8EA;EACE,2BAAA;EACA,4BAAA;AA3EF;;AA8EA;EACE,4BAAA;EACA,kBAAA;EACA,yBAAA;AA3EF;;AA8EA;EACE,+BAAA;EACA,qBAAA;EACA,4BAAA;AA3EF;;AA8EA;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;AA3EF;;AA8EA;EACE,qCAAA;EACA,qBAAA;EACA,4BAAA;AA3EF;;AA8EA;EACE,YAAA;EACA,iBAAA;AA3EF;;AA8EA;EACE,+BAAA;EACA,qBAAA;EACA,4BAAA;AA3EF;;AA+EA;EACE,iBAAA;EACA,gBAAA;EACA,iCAAA;EACA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AA5EF;;AA+EA;EACE,sBAAA;EACA,uCAAA;EACA,uBAAA;AA5EF;;AAmFA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAhFF;;AAmFA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AAhFF;;AAmFA;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAhFF;;AAmFA;EACE,kBAAA;EACA,qBAAA;AAhFF;;AAmFA;EACE,6BAAA;EACA,kBAAA;EACA,8BAAA;EACA,kCAAA;AAhFF;;AAoFA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,gBAAA;AAjFF;;AAoFA;EACE,iBAAA;EACA,8CAAA;AAjFF;;AAoFA;EACE,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,iCAAA;EACA,8BAAA;EACA,iCAAA;AAjFF;;AAuFA;EACE,aAAA;EACA,sDAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,8DAAA;EACA,+BAAA;EACA,4BAAA;AApFF;;AAwFA;EACE,qCAAA;AArFF;;AAwFA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AArFF;;AAwFA;EACE,6BAAA;EACA,qCAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;AArFF;;AAwFA;EACE,WAAA;AArFF;;AAwFA;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,8BAAA;AArFF;;AA0FA;EACE,aAAA;EACA,6FAAA;EACA,WAAA;AAvFF;;AA0FA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,+BAAA;EACA,wFAAA;AAvFF;;AA0FA;EACE,6BAAA;EACA,kCAAA;AAvFF;;AA0FA;EACE,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;AAvFF;;AA0FA;EACE,WAAA;EACA,iCAAA;EACA,wBAAA;EACA,gBAAA;AAvFF;;AA0FA;EACE,cAAA;EACA,YAAA;EACA,iCAAA;EACA,mDAAA;EACA,6CAAA;AAvFF;;AA0FA;EACE,iBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iBAAA;AAvFF;;AA2FA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,+BAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AAxFF;;AA2FA;EACE,mBAAA;EACA,iBAAA;AAxFF;;AA2FA;EACE,4BAAA;EACA,yBAAA;EACA,kBAAA;AAxFF;;AA2FA;EACE,mCAAA;EACA,gCAAA;EACA,yBAAA;AAxFF;;AA2FA;EACE,iCAAA;EACA,8BAAA;AAxFF;;AA2FA;EACE;IACE,qCAAA;IACA,WAAA;EAxFF;AACF","sourcesContent":["// Model Management – Professional layout and table design\n// Colors come from the token design system (src/styles/theme.css)\n$mm-border: var(--border);\n$mm-border-light: var(--border);\n$mm-bg: var(--page-bg);\n$mm-card-bg: var(--card);\n$mm-text: var(--foreground);\n$mm-text-muted: var(--muted-foreground);\n$mm-accent: var(--primary); /* align with theme primary */\n$mm-radius: var(--radius-sm);\n$mm-shadow: var(--shadow-sm);\n$mm-shadow-hover: var(--shadow-md);\n\n.model-mgmt-page {\n  max-width: 100%;\n  overflow-x: hidden;\n  overflow-y: visible;\n  background: var(--page-bg);\n  min-height: auto;\n  padding: 1.5rem 0 2rem;\n  box-sizing: border-box;\n}\n\n.model-mgmt-page .page-header-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.65rem 1rem;\n  padding: clamp(0.75rem, 2.5vw, 1rem) clamp(0.85rem, 3vw, 1.25rem);\n  background: var(--card);\n  border-radius: var(--radius);\n  border: 1px solid $mm-border;\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 0.5rem;\n\n  h5 {\n    margin: 0;\n    font-weight: 600;\n    font-size: 1.15rem;\n    color: $mm-text;\n    letter-spacing: -0.02em;\n  }\n\n  .btn-primary {\n    background: linear-gradient(135deg, var(--brand-500) 0%, var(--brand-700) 100%);\n    border: none;\n    font-weight: 600;\n    padding: 0.5rem 1rem;\n    border-radius: var(--radius-sm);\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n    &:hover {\n      transform: translateY(-1px);\n      box-shadow: var(--shadow-glow);\n    }\n  }\n}\n\n// Section layout – no nested row overflow\n.model-mgmt-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n// Model card – clean block, no col overflow\n.model-mgmt-card {\n  background: $mm-card-bg;\n  border-radius: var(--radius);\n  border: 1px solid $mm-border;\n  box-shadow: $mm-shadow;\n  overflow: hidden;\n  transition: box-shadow 0.25s ease, transform 0.2s ease, background 0.2s ease;\n\n  &:hover {\n    background: var(--card-hover);\n    box-shadow: var(--shadow-md);\n  }\n\n  .card-body {\n    padding: clamp(0.85rem, 3vw, 1.5rem) clamp(0.85rem, 3.5vw, 1.75rem);\n    overflow: visible;\n  }\n}\n\n// Card header – model name, project, badges\n.model-mgmt-card__header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 1.25rem;\n  padding-bottom: 1.25rem;\n  border-bottom: 1px solid $mm-border;\n  position: relative;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: -1px;\n    width: 48px;\n    height: 2px;\n    background: linear-gradient(90deg, $mm-accent, transparent);\n    border-radius: 1px;\n  }\n}\n\n.model-mgmt-card__title {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.05rem;\n\n  .model-mgmt-card__project {\n    color: $mm-text-muted;\n    font-size: 0.9rem;\n  }\n\n  .model-mgmt-card__separator {\n    color: $mm-text-muted;\n    font-weight: 300;\n  }\n\n  .model-mgmt-card__model-name {\n    font-weight: 600;\n    color: $mm-text;\n  }\n}\n\n.model-mgmt-card__badges {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n\n  .badge {\n    font-weight: 600;\n    letter-spacing: 0.3px;\n    padding: 0.3rem 0.65rem;\n    border-radius: var(--radius-sm);\n  }\n\n  .badge-success {\n    background: linear-gradient(135deg, var(--brand-500) 0%, var(--brand-600) 100%);\n    color: var(--primary-foreground);\n    border: none;\n  }\n\n  .badge-secondary {\n    background: var(--secondary);\n    color: var(--secondary-foreground);\n  }\n}\n\n// Table wrapper – horizontal scroll, no row overflow\n.model-mgmt-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: visible;\n  -webkit-overflow-scrolling: touch;\n  border-radius: var(--radius-sm);\n  border: 1px solid $mm-border;\n  background: var(--card);\n  box-shadow: var(--shadow-sm);\n}\n\n.model-mgmt-table {\n  width: 100%;\n  min-width: 800px;\n  margin: 0;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n\n  thead {\n    background: linear-gradient(180deg, var(--muted) 0%, var(--page-bg-subtle) 100%);\n    position: sticky;\n    top: 0;\n    z-index: 1;\n\n    th {\n      padding: 0.75rem 1rem;\n      text-align: left;\n      font-weight: 600;\n      font-size: 0.72rem;\n      text-transform: uppercase;\n      letter-spacing: 0.8px;\n      color: $mm-text-muted;\n      border-bottom: 2px solid $mm-border;\n      white-space: nowrap;\n    }\n  }\n\n  tbody tr {\n    border-bottom: 1px solid $mm-border-light;\n    transition: background 0.2s ease, box-shadow 0.2s ease;\n    cursor: pointer;\n\n    &:hover {\n      background: var(--primary-soft);\n    }\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  td {\n    padding: 0.85rem 1rem;\n    vertical-align: middle;\n    border: none;\n  }\n\n  // Version column – compact\n  .model-mgmt-version {\n    min-width: 140px;\n\n    .model-mgmt-version__num {\n      font-weight: 500;\n      color: $mm-text;\n    }\n\n    .model-mgmt-version__model {\n      font-size: 0.8rem;\n      color: $mm-text-muted;\n      margin-top: 0.15rem;\n    }\n  }\n\n  // Images column\n  .model-mgmt-images {\n    min-width: 100px;\n    white-space: nowrap;\n  }\n\n  // Classes column – truncate long lists\n  .model-mgmt-classes {\n    max-width: 180px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  // Metrics columns\n  .model-mgmt-metric {\n    min-width: 70px;\n    font-variant-numeric: tabular-nums;\n  }\n\n  // Actions column – compact, no overflow\n  .model-mgmt-actions {\n    position: relative;\n    min-width: 140px;\n    white-space: nowrap;\n\n    .model-mgmt-actions__group {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.35rem;\n      flex-wrap: nowrap;\n    }\n\n    .btn {\n      padding: 0.35rem 0.5rem;\n      font-size: 0.8rem;\n    }\n\n    .btn-group {\n      position: relative;\n    }\n\n  }\n}\n\n// Below md an 8-column table is not readable by dragging it sideways inside a\n// card, so each version becomes its own block and every cell shows the column\n// name it belongs to — the `data-label` set in ModelManagementMainSection.jsx.\n// (Keep the two in step: a cell with no data-label renders an empty label gap.)\n@media (max-width: 767.98px) {\n  .model-mgmt-table-wrapper {\n    overflow-x: visible;\n    border: none;\n    background: transparent;\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  .model-mgmt-table {\n    min-width: 0;\n    display: block;\n    font-size: 0.85rem;\n\n    thead {\n      display: none;\n    }\n\n    tbody {\n      display: block;\n    }\n\n    tbody tr {\n      display: block;\n      padding: 0.65rem 0.8rem;\n      border: 1px solid $mm-border;\n      border-radius: var(--radius-sm);\n      background: var(--card);\n\n      + tr {\n        margin-top: 0.6rem;\n      }\n\n      &:last-child {\n        border-bottom: 1px solid $mm-border;\n      }\n    }\n\n    td {\n      display: flex;\n      align-items: baseline;\n      justify-content: space-between;\n      gap: 0.75rem;\n      padding: 0.28rem 0;\n      min-width: 0;\n      text-align: right;\n\n      &::before {\n        content: attr(data-label);\n        flex: 0 0 8.5rem;\n        max-width: 45%;\n        text-align: left;\n        font-size: 0.66rem;\n        font-weight: 600;\n        text-transform: uppercase;\n        letter-spacing: 0.06em;\n        color: $mm-text-muted;\n      }\n    }\n\n    // Fixed widths and nowrap keep the desktop grid tidy; in a stacked row they\n    // only truncate text that now has room to wrap.\n    .model-mgmt-version,\n    .model-mgmt-images,\n    .model-mgmt-classes,\n    .model-mgmt-metric,\n    .model-mgmt-actions {\n      min-width: 0;\n      max-width: none;\n      white-space: normal;\n      overflow: visible;\n      text-overflow: clip;\n    }\n\n    .model-mgmt-version__stack {\n      min-width: 0;\n    }\n\n    .model-mgmt-actions {\n      display: block;\n      margin-top: 0.45rem;\n      padding-top: 0.6rem;\n      border-top: 1px solid $mm-border;\n      text-align: left;\n\n      // The buttons say what they do; a label above them is noise.\n      &::before {\n        display: none;\n      }\n\n      .model-mgmt-actions__group {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 0.4rem;\n      }\n    }\n  }\n}\n\n// Dropdown styles moved to src/styles/dropdown-master.scss (labelflow-dropdown-*)\n\n// Empty state\n.model-mgmt-empty {\n  text-align: center;\n  padding: 2rem;\n  color: $mm-text-muted;\n\n  .btn {\n    margin-top: 0.75rem;\n  }\n}\n\n// Loading state\n.model-mgmt-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  color: $mm-text-muted;\n}\n\n// Status badges (extend existing)\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.65rem;\n  border-radius: var(--radius-full);\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: capitalize;\n  border: 1px solid transparent;\n  transition: transform 0.15s ease, box-shadow 0.2s ease;\n}\n\n.status-badge::before {\n  content: \"\";\n  width: 0.45rem;\n  height: 0.45rem;\n  border-radius: var(--radius-full);\n  margin-right: 0.45rem;\n  background-color: currentColor;\n  opacity: 0.75;\n}\n\n.status-badge:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.status-badge--training {\n  background: var(--info-soft);\n  color: var(--info);\n  border-color: var(--info);\n}\n\n.status-badge--complete {\n  background: var(--primary-soft);\n  color: var(--success);\n  border-color: var(--success);\n}\n\n.status-badge--error {\n  background: var(--destructive-soft);\n  color: var(--destructive);\n  border-color: var(--destructive);\n}\n\n.status-badge--queued {\n  background-color: var(--warning-soft);\n  color: var(--warning);\n  border-color: var(--warning);\n}\n\n.status-badge--queued::before {\n  content: \"⏳\";\n  margin-right: 4px;\n}\n\n.status-badge--pending {\n  background: var(--warning-soft);\n  color: var(--warning);\n  border-color: var(--warning);\n}\n\n// Training log area (Live modal)\n.training-log-area {\n  max-height: 240px;\n  overflow-y: auto;\n  background: var(--page-bg-subtle);\n  color: var(--foreground);\n  border-radius: var(--radius-sm);\n  padding: 0.75rem 1rem;\n  font-family: var(--font-mono);\n  font-size: 0.75rem;\n  line-height: 1.4;\n  box-shadow: inset 0 0 0 1px var(--border);\n}\n\n.training-log-area .log-line:not(:last-child) {\n  margin-bottom: 0.35rem;\n  border-bottom: 1px dashed var(--border);\n  padding-bottom: 0.25rem;\n}\n\n// Performance metrics panel (Live Training modal) – see TrainingMetricsPanel.jsx\n// Accent per metric arrives as the --lf-metric-accent custom property on the\n// hero/tile element, so the colour stays data-driven while every other value\n// here is a token.\n.lf-metrics {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.lf-metrics__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.lf-metrics__title {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--foreground);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.lf-metrics__title i {\n  font-size: 0.75rem;\n  color: var(--primary);\n}\n\n.lf-metrics__count {\n  font-family: var(--font-mono);\n  font-size: 0.66rem;\n  color: var(--muted-foreground);\n  font-variant-numeric: tabular-nums;\n}\n\n// Shared label row: accent icon, metric name, optional Box/Mask scope chip.\n.lf-metrics__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.66rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--muted-foreground);\n  line-height: 1.2;\n}\n\n.lf-metrics__label-icon {\n  font-size: 0.7rem;\n  color: var(--lf-metric-accent, var(--primary));\n}\n\n.lf-metrics__scope {\n  font-family: var(--font-mono);\n  font-size: 0.56rem;\n  letter-spacing: 0.04em;\n  text-transform: none;\n  padding: 0.05rem 0.3rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-full);\n  color: var(--muted-foreground);\n  background: var(--page-bg-subtle);\n}\n\n// Headline metric – the lowest-ranked one present (mAP@50-95, or Top-1 for\n// classification). It gets the accent rule and the large read-out so the panel\n// has one obvious answer to \"how good is this model\".\n.lf-metrics__hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);\n  align-items: center;\n  gap: 1rem;\n  padding: 0.85rem 1rem;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-left: 3px solid var(--lf-metric-accent, var(--primary));\n  border-radius: var(--radius-sm);\n  box-shadow: var(--shadow-sm);\n}\n\n// No meter (a loss has no 0..1 scale), so don't leave a dead second column.\n.lf-metrics__hero--solo {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.lf-metrics__hero-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  min-width: 0;\n}\n\n.lf-metrics__hero-value {\n  font-family: var(--font-mono);\n  font-size: clamp(1.6rem, 4vw, 2.1rem);\n  font-weight: 700;\n  line-height: 1.05;\n  letter-spacing: -0.03em;\n  color: var(--foreground);\n  font-variant-numeric: tabular-nums;\n}\n\n.lf-metrics__hero-meter .lf-metrics__meter {\n  height: 8px;\n}\n\n.lf-metrics__unit {\n  font-size: 0.55em;\n  font-weight: 600;\n  margin-left: 0.15rem;\n  color: var(--muted-foreground);\n}\n\n// Remaining metrics – auto-fill so 2 (classification) and 8 (segmentation)\n// both fill the row without a hardcoded column count.\n.lf-metrics__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(var(--lf-metric-min, 148px), 100%), 1fr));\n  gap: 0.6rem;\n}\n\n.lf-metrics__tile {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.6rem 0.7rem;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  transition: background-color var(--transition-fast), border-color var(--transition-fast);\n}\n\n.lf-metrics__tile:hover {\n  background: var(--card-hover);\n  border-color: var(--border-strong);\n}\n\n.lf-metrics__value {\n  font-family: var(--font-mono);\n  font-size: 1.1rem;\n  font-weight: 700;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n  color: var(--foreground);\n  font-variant-numeric: tabular-nums;\n}\n\n.lf-metrics__meter {\n  height: 4px;\n  border-radius: var(--radius-full);\n  background: var(--muted);\n  overflow: hidden;\n}\n\n.lf-metrics__meter-fill {\n  display: block;\n  height: 100%;\n  border-radius: var(--radius-full);\n  background: var(--lf-metric-accent, var(--primary));\n  transition: width var(--transition-slow) ease;\n}\n\n.lf-metrics__note {\n  font-size: 0.6rem;\n  color: var(--muted-foreground);\n  letter-spacing: 0.02em;\n  min-height: 0.9em;\n}\n\n// Three distinct empty states – \"not finished yet\" is not \"nothing to report\".\n.lf-metrics__empty {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  padding: 0.7rem 0.85rem;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  font-size: 0.78rem;\n  line-height: 1.4;\n}\n\n.lf-metrics__empty i {\n  margin-top: 0.15rem;\n  font-size: 0.8rem;\n}\n\n.lf-metrics__empty--info {\n  background: var(--info-soft);\n  border-color: var(--info);\n  color: var(--info);\n}\n\n.lf-metrics__empty--danger {\n  background: var(--destructive-soft);\n  border-color: var(--destructive);\n  color: var(--destructive);\n}\n\n.lf-metrics__empty--muted {\n  background: var(--page-bg-subtle);\n  color: var(--muted-foreground);\n}\n\n@media (max-width: 575.98px) {\n  .lf-metrics__hero {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 0.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
